import styled from 'styled-components';
import { color } from '../../resources';

export const StyledContainer = styled.div`
  background-color: ${color.white};
  padding: 16px;
`;
